<template>
  <div class="d-flex">
    <v-tooltip bottom :style="styles['tooltip']" :class="classes['tooltip']">
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          v-if="chip"
          :close="close"
          :color="color"
          :label="label"
          :outlined="outlined"
          :pill="pill"
          @click:close="emit('tooltip-close')"
          :style="styles['chip']"
          :class="classes['chip']"
          :x-small="xSmall"
          :small="small"
          :large="large"
          :x-large="xLarge"
        >
          <v-icon 
            v-if="showIcon" 
            left
            :x-small="xSmall"
            :small="small"
            :large="large"
            :x-large="xLarge"
          >{{ iconType }}</v-icon>
          {{ chipText }}
        </v-chip>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import emittable from "../../mixins/emittable";

import {
  VTooltip,
  VChip,
  VIcon
} from 'vuetify/lib'

export default {
  mixins: [emittable],
  components: {
    VTooltip,
    VChip,
    VIcon
  },
  data: function () {
    return { 
      chip: true 
    };
  },
  props: {
    chipText: {
      type: String,
      default: "Test Chip",
    },
    tooltipText: {
      type: String,
      default: "Test Tooltip",
    },
    iconType: {
      type: String,
      default: "mdi-label",
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    small: {
      type: Boolean,
      default: true
    },
    xSmall: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    xLarge: {
      type: Boolean,
      default: false
    },
    label: {
      type: Boolean,
      default: false,
    },
    pill: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: Object,
      default: function () {
        return {
          chip: {},
          tooltip: {},
        };
      },
    },
    classes: {
      type: Object,
      default: function () {
        return {
          chip: {},
          tooltip: {},
        };
      },
    },
  },
  computed: {
  }
};
</script>

<style>
</style>